export default __webpack_public_path__ + "static/media/questionario.feb5ccd8.jpeg";